export default [{
	 	//证书借还
	 	path: '/CertificateBorrowOrRecord',
	 	name: 'CertificateBorrowOrRecord',
	 	meta: {
			key: 'certificate_borrow_record_id',
	 		//查看证书
	 		detail: {
	 			name: 'GetCertificateBorrowInfo',
	 		},
			keepAlive:true,
	 	},
	 	component: (resolve) => require(['@/pages/commonFunction/returnCertificate/index.vue'], resolve)
	 },
	 {
	 //查看证书详情
	 path: '/GetCertificateBorrowInfo',
	 name: 'GetCertificateBorrowInfo',
	 component: (resolve) => require(['@/pages/commonFunction/returnCertificate/detail.vue'], resolve)
	 },
	{
	//借证
	path: '/BorrowCertificate',
	name: 'BorrowCertificate',
	component: (resolve) => require(['@/pages/commonFunction/returnCertificate/borrow.vue'], resolve)
	},
	{
	//消息回复
	path: '/GetFeedbackList',
	name: 'GetFeedbackList',
	component: (resolve) => require(['@/components/sub/listMessage.vue'], resolve)
	},
	{
	//消息回复详情
	path: '/GetFeedbackInfo',
	name: 'GetFeedbackInfo',
	component: (resolve) => require(['@/pages/feedBack/detail.vue'], resolve)
	},
	{
	//帮助
	path: '/GetSystemHelpListNew',
	name: 'GetSystemHelpListNew',
	component: (resolve) => require(['@/pages/guideAffairs/useHelp/index.vue'], resolve)
	},
	{
	//帮助
	path: '/SiteNavigation',
	name: 'SiteNavigation',
	component: (resolve) => require(['@/pages/guideAffairs/urlNavigation/index.vue'], resolve)
	},
	{
	//办事指南
	path: '/HandlingGuide',
	name: 'HandlingGuide',
	component: (resolve) => require(['@/pages/guideAffairs/guide/index.vue'], resolve)
	},
	{
	//后台管理 帮助栏目
	path: '/HelpCate',
	name: 'HelpCate',
	component: (resolve) => require(['@/pages/backStageManagement/help/helpColumn/index.vue'], resolve)
	},
	{
	//后台管理 帮助内容
	path: '/HelpInfo',
	name: 'HelpInfo',
	component: (resolve) => require(['@/pages/backStageManagement/help/helpContent/index.vue'], resolve)
	},
	{
	//后台管理 帮助内容添加
	path: '/AddHelpExtend_htmlInfo',
	name: 'AddHelpExtend_htmlInfo',
	component: (resolve) => require(['@/pages/backStageManagement/help/helpContent/add.vue'], resolve)
	},
	{
	//后台管理 帮助内容编辑
	path: '/GetSystemHelpExtend_htmlDetails',
	name: 'GetSystemHelpExtend_htmlDetails',
	component: (resolve) => require(['@/pages/backStageManagement/help/helpContent/edit.vue'], resolve)
	},
	{
	//后台管理 办事指南分类
	path: '/GuidanceType',
	name: 'GuidanceType',
	component: (resolve) => require(['@/pages/backStageManagement/guide/classificationGuides/index.vue'], resolve)
	},
	{
	//后台管理 办事指南
	path: '/GuidanceInfo',
	name: 'GuidanceInfo',
	component: (resolve) => require(['@/pages/backStageManagement/guide/guideAffairs/index.vue'], resolve)
	},
	{
	//后台管理 办事指南添加
	path: '/GetWorkGuideTypeDetailExtend',
	name: 'GetWorkGuideTypeDetailExtend',
	component: (resolve) => require(['@/pages/backStageManagement/guide/guideAffairs/add.vue'], resolve)
	},
	{
	//后台管理 办事指南编辑
	path: '/GetWorkGuideDetailExtend',
	name: 'GetWorkGuideDetailExtend',
	component: (resolve) => require(['@/pages/backStageManagement/guide/guideAffairs/edit.vue'], resolve)
	},
	{
	//常用功能 我的审批
	path: '/MyApproval',
	name: 'MyApproval',
	component: (resolve) => require(['@/pages/commonFunction/myApproval/index.vue'], resolve)
	},
	{
	//常用功能 我的审批 处理
	path: '/GetCertificateRecordAuditDetail',
	name: 'GetCertificateRecordAuditDetail',
	component: (resolve) => require(['@/pages/commonFunction/myApproval/handle.vue'], resolve)
	},
	]


// WEBPACK FOOTER //
// ./src/router/map/hy.js